import './TestStoreItem.css';
import React, { useState, useRef } from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

function TestStoreItem({ test, isRecommended, onClick }) {
    const [isPressed, setIsPressed] = useState(false);
    const pressTimeoutRef = useRef(null);
    const isClosed = test.can_apply === false;
    const isApplied = test.is_applied === true;
    const isDisabled = isClosed || isApplied;

    const formatPrice = (price) => {
        if (!price) return null;
        return price.toLocaleString('ko-KR');
    };

    const getDiscountRate = () => {
        if (!test.price || !test.sale_price || test.sale_price >= test.price) return 0;
        return Math.round((1 - test.sale_price / test.price) * 100);
    };

    const hasDiscount = test.sale_price && test.price && test.sale_price < test.price;
    const discountRate = getDiscountRate();
    const isFree = !test.price || test.price === 0;

    const handleClick = () => {
        if (isDisabled) return;

        setIsPressed(true);
        if (pressTimeoutRef.current) {
            clearTimeout(pressTimeoutRef.current);
        }
        pressTimeoutRef.current = setTimeout(() => {
            setIsPressed(false);
            onClick?.();
        }, 80);
    };

    const getTimeText = () => {
        const minutes = Math.round(test.time_limit / 60);
        return `${minutes}분`;
    };

    const getDateText = () => {
        if (!test.start_time) return '상시';
        const date = new Date(test.start_time);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}/${month}/${day}`;
    };

    return (
        <div
            className={`test-store-item ${isPressed ? 'pressed' : ''} ${isDisabled ? 'disabled dimmed' : ''}`}
            onClick={handleClick}
        >
            <div className="test-store-item-content">
                <div className="test-store-item-title-row">
                    <span className="test-store-item-title">{test.title}</span>
                </div>
                {test.description && (
                    <div className="test-store-item-desc">{test.description}</div>
                )}
                <div className="test-store-item-meta">
                    {test.number_of_questions}문항 · {getTimeText()} · {test.total_score}점
                </div>
                <div className="test-store-item-date">
                    <span className="test-store-item-date-icon">📅</span>
                    <span className="test-store-item-date-value">{getDateText()}</span>
                </div>
            </div>
            <div className="test-store-item-price">
                {isApplied ? (
                    <span className="test-store-item-badge applied">신청완료</span>
                ) : isClosed ? (
                    <span className="test-store-item-badge closed">마감</span>
                ) : isFree ? (
                    <span className="test-store-item-badge free">무료</span>
                ) : (
                    <>
                        {hasDiscount && (
                            <span className="test-store-item-badge discount">{discountRate}%</span>
                        )}
                        {hasDiscount && (
                            <span className="test-store-item-price-original">{formatPrice(test.price)}원</span>
                        )}
                        <span className="test-store-item-price-current">
                            {formatPrice(hasDiscount ? test.sale_price : test.price)}원
                        </span>
                    </>
                )}
            </div>
            {!isDisabled && (
                <div className="test-store-item-arrow">
                    <ChevronRightIcon />
                </div>
            )}
        </div>
    );
}

export function TestStoreItemSkeleton() {
    return (
        <div className="test-store-item-skeleton">
            <div className="test-store-item-skeleton-content">
                <div className="test-store-item-skeleton-title-row">
                    <div className="test-store-item-skeleton-title"></div>
                    <div className="test-store-item-skeleton-badge"></div>
                </div>
                <div className="test-store-item-skeleton-desc"></div>
                <div className="test-store-item-skeleton-meta"></div>
            </div>
        </div>
    );
}

export default TestStoreItem;
